export default "__VITE_ASSET__BAuStp0x__"